export default __webpack_public_path__ + "static/media/Y7.d7f89a1c.jpg";